<template>
    <div class="kt-portlet__head">
         <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group  ">
                <label>Cognome</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Cognome" type="text" style="width:150px" v-model="search.COGNOME.VALUE">
            </div>
            <div class="form-group ">
                <label>Nome</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Nome" type="text" style="width:150px" v-model="search.NOME.VALUE">
            </div>     
            <div class="form-group ">
                <label>È un utente dell'Università</label>
                <select class="form-control form-control-sm" v-model="search.FK_ID_ENTE.VALUE">
                    <option value="">TUTTI</option>
                    <option value="1">SI</option>
                    <option value="0">NO</option>
                </select>
            </div>
            <button class="btn btn-success float-right btn-sm  mt-4 " v-on:click="creaPersonaFisica()"><i class="fas fa-user-plus"></i> Crea Persona Fisica</button>
      
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background:#226636;color:#fff">
                    <th  style="width:20%"><span >Denominazione</span></th>
                    <th  style="width:15%"><span >Codice Fiscale</span></th>
                    <th  style="width:20%"><span >Indirizzo</span></th>
                    <th  style="width:15%"><span >Contatti</span></th>
                    <th  style="width:20%"><span >Comune > Provincia > Regione</span></th>
                    <th  style="width:10%"><span >Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="personaFisica.ID_PERSONA_FISICA"  v-for="personaFisica in this.paginatedList.arr">                        
                    <td  style="width:20%;font-size:15px;font-weight:bold">
                        <i class="fas fa-user-tag" v-show="personaFisica.FK_ID_ENTE > 0"></i>
                        <i class="fas fa-user-slash" v-show="personaFisica.FK_ID_ENTE == 0"></i>
                        {{personaFisica.COGNOME != null && personaFisica.NOME != null ? personaFisica.COGNOME + ' ' + personaFisica.NOME : ''}}
                    </td>
                    <td  style="width:15%">
                        <span  style="font-size:14px">
                             {{ personaFisica.CODICE_FISCALE }} 
                        </span>
                    </td>
                    <td  style="width:20%">
                        <span  style="font-size:14px">
                             {{ personaFisica.INDIRIZZO + ' ' + personaFisica.CAP }} 
                        </span>
                    </td>
                    <td  style="width:15%">
                        <span><i class="fad fa-phone-alt"></i> {{ personaFisica.TELEFONO }}</span><br/>
                        <a :href="'mailto:'+personaFisica.EMAIL"><span><i class="fad fa-envelope"></i> {{ personaFisica.EMAIL }}</span></a>
                    </td>
                    <td  style="width:20%">
                        <strong><i class="fad fa-map-marker-alt fa-fw"></i>{{personaFisica.COMUNE_RESIDENZA != null ? personaFisica.COMUNE_RESIDENZA + ' > ' : '?' + ' > '}}</strong> {{ personaFisica.NOME_PROVINCIA!=null ? personaFisica.NOME_PROVINCIA + ' > ' : '?' + ' > '}}  <small>{{ personaFisica.NOME_REGIONE!= null ? personaFisica.NOME_REGIONE : '?' }}</small>
                    </td>
                    <td  style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button class="btn btn-warning btn-sm mr-2" style="background-color:#ffad69" v-on:click="openPraticheIntestatario(personaFisica)"><i class="fad fa-folder-open"></i></button>
                            <button class="btn btn-sm mr-2" style="background-color:rgb(37, 140, 8);" v-on:click="openPraticheIntestatario(personaFisica)"><i class="fas fa-tractor"></i></button>
                            <button data-toggle="tooltip" data-placement="top" title="Modifica il personaFisica" class="btn btn-grid btn-warning btn-sm float-right" v-on:click="modificaPersonaFisica(personaFisica.ID_PERSONA_FISICA)"><i class="fal fa-pencil"></i></button>
                            <div class="dropdown">
                                <button class="btn dropdown-toggle btn-primary" type="button" id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fa fa-print"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenu">
                                    <button class="dropdown-item" type="button">Stampa certificato concessioni</button>&nbsp;
                                    <button class="dropdown-item" type="button">Stampa avviso di pagamento</button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
         <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>

    <div class="modal fade" id="popUpPersonaFisica" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #226636;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal" :class="personaFisicaSelezionata.SESSO == 1 ? 'fa-male' : (personaFisicaSelezionata.SESSO == 2 ? 'fa-female' : 'fa-user-plus')"></i> {{personaFisicaSelezionata.COGNOME != undefined && personaFisicaSelezionata.NOME != undefined ? personaFisicaSelezionata.COGNOME +'  '+ personaFisicaSelezionata.NOME : ''}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <PersonaFisica  v-model="personaFisicaSelezionata" @ricarica="modificaPersonaFisica($event)"></PersonaFisica>       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaPersonaFisica()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>

    <PraticheIntestatario :ref="'praticheIntestatario'" :arrayStati="arrayStati"></PraticheIntestatario>


    
</template>
<script>

import Pagine from '@/components/utils/Pagine.vue' 
import PersonaFisica from '../components/common/PersonaFisica.vue';
import PraticheIntestatario from '../components/PraticheIntestatario.vue';


export default {
    name:"PersoneFisiche",
    components:{
        Pagine, 
        PersonaFisica,
        PraticheIntestatario
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                COGNOME:{TYPE:'TEXT',VALUE:''}, 
                NOME:{TYPE:'TEXT',VALUE:''}, 
                FK_ID_ENTE:{TYPE:'COMBO',VALUE:''}, 

            },
            personaFisicaSelezionata : {},
            arrayPersoneFisiche:new Array(),            
            arrayStati : new Array(),
        }
    },
    methods: {
        getPersoneFisiche : function(){
            global.utils.get('/emmet/persone_fisiche',{}, (response) => {       
                this.arrayPersoneFisiche = response.data           
            });
        },
        getPersonaFisica: function(idPersonaFisica){            
            global.utils.get('emmet/persona_fisica',{ID_PERSONA_FISICA: idPersonaFisica},(response)=>{
                this.personaFisicaSelezionata = utils.clone(response.data); 
            }) 
        },      
        creaPersonaFisica : function(){
            this.personaFisicaSelezionata = {ID_PERSONA_FISICA:0,FK_ID_ENTE:0}
            var modal = utils.openModal('popUpPersonaFisica'); 
        },
        modificaPersonaFisica : function(idPersonaFisica){
            //api persona fisica
            var modal = utils.openModal('popUpPersonaFisica');
            this.getPersonaFisica(idPersonaFisica)
        
        },
        deletePersonaFisica : function(idPersonaFisica){
            utils.alert.confirm("Sei sicuro di voler eliminare la persona fisica?",()=>{
                global.utils.delete('/emmet/persona_fisica',{ID_PERSONA_FISICA: idPersonaFisica},(response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                        this.getPersoneFisiche();
                    }

                });
            },this.$root);  
        },
        salvaPersonaFisica : function(){
            //update
            if(this.personaFisicaSelezionata.ID_PERSONA_FISICA> 0){
                global.utils.put('/emmet/persona_fisica',this.personaFisicaSelezionata, (response) => {
                    if (response.esito == 0){

                        this.getPersoneFisiche();
                        var modal = utils.closeModal('popUpPersoneFisica')
                        utils.alert.success(response.messaggio);
                    }
                });
            }else{
            //insert
                global.utils.post('/emmet/persona_fisica',this.personaFisicaSelezionata,(response)=>{
                    if (response.esito == 0){
                        this.getPersoneFisiche()
                        var modal = utils.closeModal('popUpPersonaFisica')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        openPraticheIntestatario : function(persona){
            this.$refs.praticheIntestatario.praticheIntestatario(persona,1);
        }

       
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayPersoneFisiche,this.search);
            return arr;
        }, 
    },
    created : function(){
        global.utils.get('/emmet/stati',{}, (response) => {       
            this.arrayStati = response.data
            this.getPersoneFisiche()
        });
    },

}


</script>
